{
  "version": 1,
  "asset_id": "a26d86ed-7e66-4ee8-b5ac-cacb661234d7",
  "project_id": "a3e359cb-5308-4f2a-8ac0-def799d4abdd",
  "url": "/__l5e/assets-v1/a26d86ed-7e66-4ee8-b5ac-cacb661234d7/hero-fetiche.mp4",
  "r2_key": "a/v1/a3e359cb-5308-4f2a-8ac0-def799d4abdd/a26d86ed-7e66-4ee8-b5ac-cacb661234d7/hero-fetiche.mp4",
  "original_filename": "hero-fetiche.mp4",
  "size": 603556,
  "content_type": "video/mp4",
  "created_at": "2026-11-03T17:23:20Z"
}
